'use client';

import { usePathname, useRouter } from '@/i18n/routing';

export default function SampleButton({ children, className, formName }) {
  const router = useRouter();
  let pathName = usePathname();
  if (
    pathName.includes('market-size') ||
    pathName.includes('market-trends') ||
    pathName.includes('market-share') ||
    pathName.includes('companies')
  ) {
    const pathNameArray = pathName.split('/');
    pathNameArray.pop();
    pathName = pathNameArray.join('/');
  }

  const handleClick = () => {
    if (formName === 'Request Customization') {
      router.push(`${pathName}/request-customization`);
    } else {
      router.push(`${pathName}/request-sample`);
    }
  };

  return (
    <div className="text-center justify-center flex w-auto items-center hover:cursor-pointer">
      <button
        className={`${className} hover:cursor-pointer`}
        onClick={handleClick}
      >
        {children}
      </button>
      {/* <LeadForm isOpen={isOpen} setIsOpen={setIsOpen} formType={formName} /> */}
    </div>
  );
}
